import React from "react";
import cn from "classnames";

const ProgressBarItem = props => {
  const {
    id,
    title,
    isDisabled,
    progress,
    surveyId,
    linearExtraId
  } = props;

  return (
    <div>
      <svg
        width="202"
        height="48"
        viewBox="0 0 202 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <linearGradient id={`progressFill_${surveyId}_${id}${linearExtraId}`}>
          <stop offset={`${progress}%`} stopColor="hsla(0, 81%, 92%, 1)" />
          <stop offset={`${progress}%`} stopColor="hsla(0, 0%, 100%, 1)" />
        </linearGradient>
        <path
          d="M1.76777 3.06066C0.82282 2.11571 1.49207 0.5 2.82843 0.5H177.172C177.569 0.5 177.951 0.658034 178.232 0.939342L200.232 22.9393C200.818 23.5251 200.818 24.4749 200.232 25.0607L178.232 47.0607C177.951 47.342 177.569 47.5 177.172 47.5H2.82843C1.49207 47.5 0.82282 45.8843 1.76777 44.9393L20.9393 25.7678C21.9156 24.7915 21.9156 23.2085 20.9393 22.2322L1.76777 3.06066Z"
          stroke={isDisabled ? "" : "#EC5E59"}
          fill={
            isDisabled
              ? "hsla(213, 100%, 12%, 0.04)"
              : `url(#progressFill_${surveyId}_${id}${linearExtraId})`
          }
        />
        <text
          className={cn("progressBarText", {
            progressBarText_disabled: isDisabled
          })}
          x={202 / 2}
          y={48 / 2}
          dominantBaseline="middle"
          textAnchor="middle"
        >
          {title}
        </text>
      </svg>
    </div>
  );
};

export default ProgressBarItem;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/peer-evaluation-modal/progress-bar-item.js